import { useEffect, useState } from "react";
import { uploadDocument } from "../services/api";
import API from "../services/api";

function UploadDocs({ projectId }) {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  // =========================
  // LOAD FILES
  // =========================
  const loadFiles = async () => {
    if (!projectId) return;

    try {
      const res = await API.get(`/files/${projectId}`);
      setFiles(res.data);
    }
      catch(err){
        console.error("Failed to load files:", err);

      }
  };

  useEffect(() => {
    loadFiles();
  }, [projectId]);

  // =========================
  // UPLOAD
  // =========================
  const handleUpload = async () => {
    if (!file) {
      setMessage("Please select a file");
      return;
    }

    if (!projectId) {
      setMessage("Please select a project first");
      return;
    }

    const allowed = [".pdf", ".txt", ".docx"];

    if (!allowed.some(ext => file.name.toLowerCase().endsWith(ext))) {
      setMessage("Only PDF, TXT, DOCX allowed");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      await uploadDocument(file, projectId); // ✅ FIXED
      setMessage("File uploaded successfully ✅");
      setFile(null);
      loadFiles(); // 🔥 refresh list
    } catch (err) {
      setMessage("Upload failed ❌");
    }

    setLoading(false);
  };

  // =========================
  // DELETE
  // =========================
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this file?")) return;

    try {
      await fetch(`http://localhost:8000/files/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      loadFiles();
    } catch (err) {
      console.error("Delete failed");
    }
  };

  // =========================
  // UI
  // =========================
  return (
    <div className="bg-white p-4 rounded-xl shadow mb-4">

      <h3 className="font-bold mb-3 text-blue-600">
        📄 Upload Documents (RAG)
      </h3>

      {/* No project selected */}
      {!projectId && (
        <p className="text-yellow-600 mb-2">
          Please select a project first
        </p>
      )}

      {/* Upload Section */}
      <div className="flex gap-2 mb-3">
        <input
          type="file"
          accept=".pdf,.txt,.docx"
          onChange={(e) => setFile(e.target.files[0])}
          className="border p-2 rounded w-full"
        />

        <button
          onClick={handleUpload}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          {loading ? "Uploading..." : "Upload"}
        </button>
      </div>

      {/* Message */}
      {message && (
        <p className="text-sm mb-3">{message}</p>
      )}

      {/* File List */}
      {files.length > 0 && (
        <div className="space-y-2">
          {files.map((f) => (
            <div
              key={f.id}
              className="flex justify-between items-center bg-gray-50 p-2 rounded"
            >
              <span className="text-sm">
                {f.name || f.filename}
              </span>

              <button
                onClick={() => handleDelete(f.id)}
                className="text-red-500 text-sm"
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default UploadDocs;